import React, { useState } from 'react';
import { ILadderService, Standing, Statement } from '../../../model/interfaces';
import PlayerRow from '../../common/playerRow/playerRow';
import { IUserService, WeekGame } from '../../../../user/model/interfaces';
import styles from './standingsRow.module.scss';
import classNames from 'classnames';
import LadderPointsStatement from '../ladderPointsStatement/ladderPointsStatement';
import Weekgames from '../weekgames/weekgames';
import RowLoader from '../../common/rowLoader/rowLoader';

const cells: Array<keyof Standing> = [
  'Rank',
  'BestRank',
  'NGames',
  'NWon',
  'WinPC',
  'Streak',
  'BestStreak',
  'NTourneys',
  'NTourneysWon',
  'NTrnGames',
  'NTrnGamesWon',
  'Idle',
];

type AdditionalInfo = {
  statement?: Statement;
  weekgames?: WeekGame[];
  ladderPoints?: number;
};
export default function StandingsRow(props: {
  player: Standing;
  ladderService: ILadderService;
  userService: IUserService;
}) {
  const player = props.player;
  const [additionalInfo, setAdditionalInfo] = useState<AdditionalInfo>({
    statement: undefined,
    weekgames: undefined,
    ladderPoints: undefined,
  });
  const [loading, setLoading] = useState(false);

  async function getAdditionalInfo(userId: string) {
    if (loading) return;
    let newStatement: Statement | undefined;
    let newWeekgames: WeekGame[] | undefined;
    let newLadderPoints: number | undefined;

    if (!additionalInfo.statement) {
      try {
        setLoading(true);
        newStatement = await props.ladderService.getStatement(userId);
        const userInfo = await props.userService.getPlayerStats(userId);
        newWeekgames = userInfo.weekgames;
        newLadderPoints = userInfo.LPoints;
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    setAdditionalInfo({
      statement: newStatement,
      weekgames: newWeekgames,
      ladderPoints: newLadderPoints,
    });
  }

  return (
    <>
      <tr
        key={player.UserID}
        onClick={() => getAdditionalInfo(player.UserID)}
        className={classNames(styles.dataRow, additionalInfo.statement && styles.dataRow_selected)}
      >
        <td>
          <PlayerRow
            name={player.Name}
            avatar={`https://gamecolony.com/cgi-bin/get_avatar.plx?size=6&uid=${player.UserID}`}
          />
          <RowLoader loading={loading} />
        </td>
        {cells.map((cell) => (
          <td key={cell}>{player[cell]}</td>
        ))}
      </tr>
      {additionalInfo.statement?.events ? (
        <tr className={styles.additional}>
          <td colSpan={13}>
            <div className={styles.content}>
              <Weekgames weekgames={additionalInfo.weekgames} />
              <LadderPointsStatement
                statement={additionalInfo.statement}
                ladderPoints={additionalInfo.ladderPoints}
              />
            </div>
          </td>
        </tr>
      ) : null}
    </>
  );
}
